import { createAction } from '../../store/createAction';

export const request = createAction('request/REQUEST', (actionType: string, id: string) => ({
    actionType,
    id,
}));
